export default (data) => ({
  type: data.type,
  lunchTimeStart: data.lunchTimeStart,
  lunchTimeEnd: data.lunchTimeEnd,
  baselineStart: data.baselineStart,
  baselineEnd: data.baselineEnd,
  endOfReportingWeek: data.endOfReportingWeek,
  weatherLocation: data.weatherLocation,
})
